import React from 'react'

const Manual_redimir_giftcards_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Redimir Gift Cards en el e-commerce de Clau.io
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo los usuarios pueden redimir gift cards desde el sitio web del e-commerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Redimir_Gift_Cards_en_el_e-commerce_de_Clau_io__8O9sKe6EQZeB9kRUV8iZeA?as=scrollable"
          className="scribe-iframe-general-125"
          width="100%"
          height="4200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_redimir_giftcards_ecommerce
